import React, { useContext, useEffect, useState } from "react";
import useLocalStorage from "../Hooks/useLocalStorage";
import { DataContext } from '../contexts/DataContext';
const API_BASE_URL = window.ENV?.REACT_APP_RUGBY_API || process.env.REACT_APP_RUGBY_API || "";

export function usePullFightPrediction(game) {
    const {gamesByDate, selectedGame} = useContext(DataContext)
      const [GameSave, setGameSave] = useLocalStorage();
      useEffect(() => {
        if (gamesByDate && gamesByDate.length > 0) {
          setGameSave({
            ...GameSave,
            cachedGames: gamesByDate
          });
        }
      }, [gamesByDate]);
      const activeGames = gamesByDate || GameSave.cachedGames || [];

    const pullFightPrediction = async () => {
    const currentFight = GameSave.cachedGames?.findIndex(
        (game) => game._id === selectedGame?._id
    );
    const totalFights = GameSave.cachedGames?.length || 0;
    const id = totalFights > 0 && currentFight >= 0
    ? (totalFights - currentFight)
    : null
    const response = await fetch(`${API_BASE_URL}/fanprediction/${id}`);
    const predictionData = await response.json();
    return predictionData;
    };
    return pullFightPrediction;
}

export async function pullFightPredictionstatic(id) {
    const response = await fetch(`${API_BASE_URL}/fanprediction/${id}`);
    const predictionData = await response.json();
    return predictionData;
}


export async function pullAllFightPredictions() {
    const response = await fetch(`${API_BASE_URL}/allfights`);
    const allpredictions = await response.json();
    return allpredictions;
}